import { BaseAddressDto } from './baseAddress.dto';
import { CustomerDto } from './customer.dto';

export class CustomerAddressDto extends BaseAddressDto {
  isBilling: boolean;
  isDelivery: boolean;
  addressName: string;
  isDefault: boolean;
  customer: CustomerDto;
  insidePolygon?: boolean;
}
